import {
  AssetType,
  CalculationCountry,
  DkTaxCode,
  Owner,
  Payment,
  PaymentFrequency,
  PensionCoverage,
  Policy,
} from '@dreamplan/autogenerated-clients/calculation';
import { TestProfileWithAnswers } from '@dreamplan/types';
import { sharedDefaultAnswers } from '../sharedProfileAnswers';

export const Katrine: TestProfileWithAnswers = {
  name: 'Katrine',
  answers: [
    ...sharedDefaultAnswers,
    {
      key: 'isUserSelfEmployed',
      value: 'false',
    },
    {
      key: 'userCurrentPensionMonthlyPayment',
      value: 6750,
    },
    {
      key: 'userAge',
      value: 1979,
    },
    {
      key: 'userFullName',
      value: 'Katrine',
    },
    {
      key: 'hasSpouse',
      value: 'false',
    },
    {
      key: 'userMonthlySalary',
      value: 45000,
    },
    {
      key: 'userCurrentPensionSavings',
      value: 2000000,
    },
    {
      key: 'houseAddress',
      value: 'test adresse',
    },
    {
      key: 'houseOwnershipType',
      value: 'Own',
    },
    {
      key: 'houseValue',
      value: 1500000,
    },
    {
      key: 'houseDebt',
      value: 1300000,
    },
    {
      key: 'houseDebtInterest',
      value: 1,
    },
    {
      key: 'houseDebtRemainingTenure',
      value: 29,
    },
    {
      key: 'houseDebtHasRepaymentFreeYears',
      value: 'false',
    },
    {
      key: 'userMonthlySavingsAmount',
      value: 1000,
    },
    {
      key: 'userCurrentEmergencySavings',
      value: 50000,
    },
    {
      key: 'fetchPensionInformation',
      value: 'false',
    },
    {
      key: 'hasSecondHouse',
      value: 'false',
    },
    {
      key: 'userName',
      value: 'Katrine',
    },
  ],

  expectedPayload: {
    primary: {
      birthYear: 1979,
      pensionAge: 69,
      deathAge: undefined,
    },
    incomes: [
      {
        id: 'primary-income',
        owner: Owner.Primary,
        payment: {
          type: 'Payment',
          paymentFrequency: PaymentFrequency.Monthly,
          amount: 45000,
        } as Payment,
      },
    ],
    municipalityId: undefined,
    spouse: undefined,
    companies: undefined,
    policies: [
      {
        id: 'dd5f84da-066d-4610-8753-4d4e9fc8960p',
        owner: Owner.Primary,
        coverages: [
          {
            type: 'PensionCoverage',
            id: 'dd5f84da-066d-4610-8753-4d4e9fc8960p',
            owner: Owner.Primary,
            initialValue: 2000000,
            taxCode: DkTaxCode.One,
            contribution: {
              type: 'PensionContribution',
              paymentFrequency: PaymentFrequency.Monthly,
              amount: 6750,
              isFromEmployer: undefined,
            },
            payOutType: {
              type: 'LifeAnnuity',
              payOutDate: undefined,
            },
          } as PensionCoverage,
        ],
      } as Policy,
    ],
    housesWithLoans: [
      {
        id: 'dd5f84da-066d-4610-8753-4d4e9fc8960f',
        houseValue: 1500000,
        type: 'HouseWithLoans',
        loans: [
          {
            id: 'd9497ef5-9d8a-4c03-8308-cbee6746339c',
            remainingPrincipal: 1300000,
            type: 'AmortizedLoan',
            contributionFeeRate: 0.006999999999999999,
            interestRate: 0.01,
            redemptionDetails: {
              // bondPrice: 0,
              redemptionFee: 5000,
            },
            remainingRepaymentFreeYears: 0,
            remainingTenure: 29,
          },
        ],
      },
    ],
    liquidAssets: [
      {
        id: 'dd5f84da-066d-4610-8753-4d4e9fc8960h',
        assetType: AssetType.Stocks,
        initialValue: 50000,
        monthlyDeposit: {
          type: 'Payment',
          amount: 1000,
          paymentFrequency: PaymentFrequency.Monthly,
        } as Payment,
      },
    ],
    dreams: undefined,
    calculationCountry: CalculationCountry.Dk,
    recommendationSettings: {
      companyRecommendation: undefined,
      primaryPensionRecommendation: undefined,
      spousePensionRecommendation: undefined,
      emergencySavingRecommendation: undefined,
      loanRecommendation: {
        type: 'RestrictedLoanToValueRatioGoalSeek',
        ratio: undefined,
        establishmentDetails: {
          foundationFee: 20000,
          // bondPrice: 98,
        },
        // interestRate: 0.06,
        // contributionFeeRate: 0.02,
      },
    },
  },
  expectedResult: undefined,
};
